/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Panel, PanelBody, PanelHeader } from '../../../util/panel';
import { Button, Select, Table } from 'antd';
import { FaEye, FaEyeSlash, FaPen, FaPlus } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import usePaginationHook from '../../../../utils/usePagination';
import { useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { AlertConfirm, AlertError, AlertSuccess } from '../../../util/Alert';
import { FormProvider, useForm } from 'react-hook-form';
import 'dayjs/locale/th';
import { useHistory } from 'react-router';
import {
  legacySurveyPartFormDefaultValues,
  legacySurveyPartFormSchema,
} from '../components/dto/legacy-survey-form.dto';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

import { FiArrowLeft } from 'react-icons/fi';
import fitSurvey2Services from '../../../../services/fit-survey2.services';
import LegacySurveyPartModal from '../components/modal/LegacySurveyPartModal';
import { error } from 'jquery';

dayjs.locale('th');

const pageSize = 10;

const LegacySurvey2PartPage = () => {
  const [legacySurveyPartFormOpen, setLegacySurveyPartFormOpen] =
    useState(false);
  const {
    data: legacySurveyPartLists,
    setData,
    page,
    setPage,
    total,
    setTotal,
  } = usePaginationHook();
  const queryClient = useQueryClient();
  const history = useHistory();
  const params = useParams();

  const legacySurveyPartForm = useForm({
    defaultValues: legacySurveyPartFormDefaultValues,
    resolver: legacySurveyPartFormSchema(),
  });

  const _HandleLegacySurveyPartFormOpen = (formType) => {
    legacySurveyPartForm.setValue('formType', formType);
    setLegacySurveyPartFormOpen(true);
  };

  const _HandleLegacySurveyPartFormClose = () => {
    legacySurveyPartForm.reset(legacySurveyPartFormDefaultValues);
    setLegacySurveyPartFormOpen(false);
  };

  const { isFetching: legacySurveyPartListsLoading } =
    fitSurvey2Services.useQueryGetLegacySurveyPartLists(
      { take: pageSize, page, surveyId: params.surveyId },
      (data) => {
        setData(data.data);
        setTotal(data.meta.total);
      },
    );

  const { mutate: deleteLegacySurveyPart } =
    fitSurvey2Services.useMutationDeleteLegacySurveyPart(
      () => {
        queryClient.invalidateQueries({
          queryKey: ['get-legacy-survey2-part'],
          refetchType: 'all',
        });
      },
      (error) => {
        AlertError({
          title: 'ไม่สามารถดำเนินการได้',
          text: error,
        });
      },
    );

  const { mutate: updateLegacySurveyPartDisplay } =
    fitSurvey2Services.useMutationUpdateLegacySurveyPartDisplay(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey2-part'],
        refetchType: 'all',
      });
    });

  const { mutate: updateLegacySurveyPartIndex } =
    fitSurvey2Services.useMutationUpdateLegacySurveyPartIndex(
      () => {
        AlertSuccess('อัพเดทสำเร็จ');
        queryClient.invalidateQueries({
          queryKey: ['get-legacy-survey2-part'],
          refetchType: 'all',
        });
      },
      (error) => {
        AlertError({
          title: 'ไม่สามารถดำเนินการได้',
          text: error,
        });
      },
    );

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'index',
      key: 'index',
      render: (_, record) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Select
            value={record.index}
            style={{ width: 80 }}
            onChange={(value) => {
              updateLegacySurveyPartIndex({
                id: record.id,
                index: value,
              });
            }}
          >
            {Array.from({ length: total }).map((item, index) => {
              return (
                <Select.Option key={String(index + 1)} value={index + 1}>
                  {index + 1}
                </Select.Option>
              );
            })}
          </Select>
        </div>
      ),
      width: 100,
    },
    {
      title: 'หัวข้อ',
      dataIndex: 'title',
      key: 'title',
      render: (_, record) => <span>{record.title}</span>,
      width: 300,
    },
    {
      title: 'การมองเห็น',
      dataIndex: 'display',
      key: 'display',
      render: (_, record) => <span>{record.display ? 'เปิด' : 'ปิด'}</span>,
    },
    {
      title: 'อัปเดตเมื่อ',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (_, record) => (
        <span>{dayjs(record.updatedAt).format('DD/MMM/YYYY')}</span>
      ),
      sorter: (a, b) =>
        dayjs(a.updatedAt).diff(dayjs(b.updatedAt), 'D') > 0 ? 1 : -1,
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <div
          style={{ display: 'flex', justifyContent: 'center' }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {record.display ? (
            <div
              style={{ cursor: 'pointer', marginLeft: 10 }}
              onClick={async () => {
                const confirm = await AlertConfirm('ปิดการแสดงหมวดหมู่คำถาม');
                if (confirm)
                  updateLegacySurveyPartDisplay({
                    id: record.id,
                    display: false,
                  });
              }}
            >
              <FaEye />
            </div>
          ) : (
            <div
              style={{ cursor: 'pointer', marginLeft: 10 }}
              onClick={async () => {
                const confirm = await AlertConfirm('เปิดการแสดงหมวดหมู่คำถาม');
                if (confirm)
                  updateLegacySurveyPartDisplay({
                    id: record.id,
                    display: true,
                  });
              }}
            >
              <FaEyeSlash />
            </div>
          )}
          <div
            style={{ cursor: 'pointer', marginLeft: 10 }}
            onClick={() => {
              legacySurveyPartForm.setValue('id', record.id);
              _HandleLegacySurveyPartFormOpen('edit');
            }}
          >
            <FaPen />
          </div>
          <div
            style={{ cursor: 'pointer', marginLeft: 10 }}
            onClick={async () => {
              const confirm = await AlertConfirm('ลบข้อมูล');
              if (confirm) deleteLegacySurveyPart({ id: record.id });
            }}
          >
            <MdDelete />
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <h3
          onClick={() => {
            history.goBack();
          }}
          className="mr-2"
          style={{ cursor: 'pointer' }}
        >
          <FiArrowLeft />
        </h3>
      </div>
      <Panel>
        <PanelHeader>คำถาม</PanelHeader>
        <PanelBody>
          <div
            style={{ display: 'flex', alignItems: 'center' }}
            className="mb-2"
          >
            <div style={{ flex: 1 }} />
            <Button
              onClick={() => {
                _HandleLegacySurveyPartFormOpen('create');
              }}
              type="primary"
            >
              <FaPlus className="mr-2" />
              เพิ่มหัวข้อย่อย
            </Button>
          </div>
          <Table
            columns={columns}
            dataSource={legacySurveyPartLists}
            loading={legacySurveyPartListsLoading}
            style={{ backgroundColor: '#fff' }}
            rowKey="id"
            scroll={{ x: 'max-content' }}
            onChange={({ current }) => {
              setPage(current);
            }}
            pagination={{
              pageSize: 10,
              total,
            }}
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  history.push(
                    `/questionaire/survey2/${params.surveyId}/part/${record.id}`,
                  );
                },
              };
            }}
          />
        </PanelBody>
        <FormProvider {...legacySurveyPartForm}>
          <LegacySurveyPartModal
            open={legacySurveyPartFormOpen}
            handleClose={_HandleLegacySurveyPartFormClose}
          />
        </FormProvider>
      </Panel>
    </>
  );
};

export default LegacySurvey2PartPage;
